<template>
  <v-row>
    <v-col cols="12" lg="8">
      <h3>
        {{ title }}
      </h3>
    </v-col>
    <v-col cols="12" lg="4">
      <router-link v-if="link" :to="link">
        <v-btn color="primary" dark>{{ buttonText }}</v-btn>
      </router-link>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import Vue from 'vue';
export default Vue.extend({
  name: 'CallToAction',
  props: {
    title: String,
    link: String,
    buttonText: {
        type: String,
        default: 'Go To Action'
    },
  },
});
</script>
